<template>
  <v-main class="signin">
    <head>
      <meta name="viewport" content="width=device-width,initial-scale=1.0">
    </head>
    <link href="tablet.css" rel="stylesheet" type="text/css" media="(min-width: 320px) and (max-width: 639px)" >
    <link href="tablet.css" rel="stylesheet" type="text/css" media="(min-width: 640px) and (max-width: 1023px)" >
    <link href="desktop.css" rel="stylesheet" type="text/css" media="(min-width: 1024px)" >
    <v-card class="all" height="auto" width="70vw" color="white" elevation="0">
      <v-row>
        <v-col cols="5" class="text-center">
          <!--画像-->
          <img src="../../assets/png/Liqlid_icon_logo.png" class="logo">
        </v-col>
        <v-col cols="7" class="rightside">
          <!--通知-->
          <v-card color="#CCE8FF" class="my-4" align="center" elevation="0">
            <v-card-text v-if="resign === 'set'" class="font-weight-black">メールアドレスの確認が完了しました<br>もう一度ログインしてください</v-card-text>
            <v-card-text v-if="resign === 'reset'" class="font-weight-black">パスワードの再設定が完了しました<br>新しいパスワードでログインしてください</v-card-text>
          </v-card>
          <div class="LoginFont">
            ログイン
          </div>
          <!--Error-->
          <div class="errbar">
            <p v-if="acer === true">アカウントが存在しません<br>管理者にお問い合わせください</p>
            <p v-if="noac === true">アカウントが作成されていません<br>上記のタブから「新規登録」を開いてください。</p>
            <p v-if="aller === true">全ての項目を<br>正しく入力してください</p>
            <p v-if="emer === true">メールアドレスの形式が違います<br>もう一度正しく入力してください</p>
            <p v-if="pwer === true">パスワードが違います<br>もう一度正しく入力してください</p>
          </div>
          <!--入力フォーム-->
          <v-form>
            <div class="mailConform">
              <p class="mailConformFont">職員番号</p>
              <v-text-field class="mailform" v-model="number" :rules="[rules.numberrequired, rules.number]">
              </v-text-field>             
              <p class="passwordConformFont">パスワード</p>
              <v-text-field class="passwordform" v-model="password" :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'" :rules="[rules.passrequired, rules.min]" :type="show1 ? 'text' : 'password'"
                name="input-10-1" hint="8文字以上入力してください" counter @click:append="show1 = !show1"></v-text-field>
            </div>
          </v-form>

          <!-- ForgotPassword -->
          <div class="forgetpassword" v-if="passwordResetLink">
            <a :href="passwordResetLink" class="forgetpasswordtext">
              >パスワードを忘れた
            </a>
          </div>
         

          <!--CheckBox-->
          <v-checkbox v-model="checkbox" label="次回から自動でログイン" class="checkbox"></v-checkbox>

          <!--LoginBtn-->
          <v-btn class="loginbtn" @click="signin()" color="#008cff" outlined :disabled="password.length <= 7 || !number"
            style="text-transform: none; font-family: mplus-2c-bold; font-size: 20px; border-width:3px;">
            Login
          </v-btn>     
        </v-col>
      </v-row>
      <!--戻るボタン-->
      <div justifiy-content-center>
        <v-btn class="back" color="back" text href="/home">
          <span style="color:#008CFF">＜</span> &nbsp; &nbsp;戻る &nbsp; &nbsp;<span style="color:#008CFF">＞</span>
        </v-btn>
      </div>
    </v-card>
  </v-main>
</template>
<script>
import firebase from 'firebase'
import Vue from 'vue'
import VueMq from 'vue-mq'
import Toasted from "vue-toasted";
Vue.use(Toasted,{iconPack : 'material'})
const thisEnvId = process.env.VUE_APP_TEMP_CITY_ID || '';
Vue.use(VueMq, {
  breakpoints: { // default breakpoints - customize this
    sp: 959,
    pc: 960
  },
  defaultBreakpoint: 'pc' // customize this for SSR
})
export default {
  data () {
    return {
      show1: false,
      number: '',
      resign: this.$route.query.id,/*reset or set*/
      password: '',
      rules: {
        numberrequired: value => !!value || '職員番号を入力してください',
        passrequired: value => !!value || 'パスワードを入力してください',
        min: v => v.length >= 8 || '8文字以上入力してください',
        number: v => !(!(v.match(/^[0-9]+/))) || 'この職員番号は有効ではありません',
      },
      checkbox: true,
      errorMessage: '',
      passwordResetLink: thisEnvId == "kawachinagano-city" ? "https://liqlid-officer-password-reset.netlify.app/kawachinagano" : thisEnvId == "kamakura" ? "https://liqlid-password-reset.netlify.app/kamakura" : ""
    }
  },
  methods: {
    async signin() {
      const email = `${this.number}+govstaff@${thisEnvId}.liqlid.local`
      this.loading = true
      var self = this
      const res = await this.$store.dispatch('auth/signInWithEmailAndPassword', { email: email, password: this.password, checkForPersist: this.checkbox });
      //console.log(res)
      if (res.success) {
        this.$router.push('/home')
        return
      } else if (thisEnvId === 'kamakura') {
        // TODO: アカウントが存在しないけど実は鎌倉で既に作っていた場合の処理
        const functions = firebase.functions()
        const numberSignin = functions.httpsCallable(`numberSignin`)
        const { data } = await numberSignin({ numberId: this.number, password: this.password })
        const retryRes = await this.$store.dispatch('auth/signInWithEmailAndPassword', { email: email, password: this.password, checkForPersist: this.checkbox });
        if (retryRes.success) {
          this.$router.push('/home')
        }
        return
      }
      this.errorMessage = res.message
      let toastMessage = ''
      switch (res.message) {
        case 'errorAccountDisabled':
          toastMessage = 'アカウントが存在しません。管理者にお問い合わせください。'
          break;
        case 'errorNoAccount':
          toastMessage = 'アカウントが作成されていません。'
          break;
        case 'aller':
          toastMessage = '全ての項目を正しく入力してください。'
          break;
        case 'errorEmailInValid':
          toastMessage = 'メールアドレスの形式が違います。もう一度正しく入力してください。'
          break;
        case 'errorPasswordInvalid':
          toastMessage = 'パスワードが違います。もう一度正しく入力してください。'
          break;
        case 'errorEmailNotVerified':
          toastMessage = 'メールアドレスを確認する必要があります。認証メールを送信いたしましたのでご確認ください。'
          break;
        case 'errorUnknown':
          toastMessage = '不明なエラーが発生しました。時間をおいて再度お試しください。'
          break;
        default:
          toastMessage = 'エラーが発生しました。時間をおいて再度お試しください。'
          break;
      }
      this.showToast(toastMessage)
    },
    showToast(message="エラーが発生しました"){
      this.$toasted.show(message, {
        theme: "bubble", 
        position: "bottom-center", 
        duration : 5000,
      });
    },
  },
}
</script>
<style scoped>
.login{
  position: relative;
  top: 40%;
  left: 10%;
}
.title{
  position: relative;
  top: -25px;
  left: -20px;
  font-family:mplus-2c-medium;
}
.signin {
  background-size:cover;
  width:100%;
}
.img1 {
  position: fixed;
  left: 30%;
  top: 22%;
}
.errbar{
  border-left: solid #E64550;
  border-right: solid #E64550;
  color: #E64550;
}
*{
  font-family:mplus-2c-medium;
  font-size:20px;
}
/*====================
PCを基本設計にする
 - 1280px〜：大型PC
 - 960px〜1279px：小型PC
 - 600px〜959px：タブレット
 - 480px〜599px：スマートフォン横
 - 〜479px：スマートフォン縦
====================*/

/* 1280px〜：大型PC
------------------------------ */
@media screen and (min-width:1280px) {
.all{
  position: relative;
  left:17%;
  top:30%;
}
.logo{
  position: relative;
  top:20%; 
  height:350px;
}
.LoginFont{
  position: relative;
  font-size: 40px;
  left:30%;
}
.mailConform{
  position: relative;
  top:25px;
  left:15px;
}
.mailConformFont{
  font-size:25px;
}
.passwordConformFont{
  font-size:25px;
}
.mailform{
  max-width: 80%;
}
.passwordform{
  max-width: 80%;
}
.forgetpassword{
  position: relative;
  top:3%;
  left:50%;
}
.forgetpasswordtext{
  font-size: 17px;
}
.checkbox{
  position: relative;
  top:20px;
  left:28%;
}
.linebtn{
  margin-top: 3%;
}
.loginbtn{
  width:35%;
  position: relative;
  top:20px;
  left:-5%; 
}
.back{
  position: relative;
  top:50px;
  left:30%;
  font-size: 40px;
}
}

/* 960px〜1279px：小型PC
------------------------------ */
@media screen and (min-width:960px) and (max-width:1279px) {
.all{
  position: relative;
  left:13%;
  top:10%;
}
.logo{
  position: relative;
  top:20%;
  left:10%;
  height: 250px; 
  max-height: 60%; 
}
.LoginFont{
  position: relative;
  font-size: 40px;
  left:30%;
}
.mailConform{
  position: relative;
  top:25px;
  left:15px;
}
.mailConformFont{
  font-size:25px;
}
.passwordConformFont{
  font-size:25px;
}
.mailform{
  max-width: 80%;
}
.passwordform{
  max-width: 80%;
}
.forgetpassword{
  position: relative;
  top:0%;
  left:50%;
  font-size:40px;
}
.forgetpasswordtext{
  font-size:15px;
}
.checkbox{
  position: relative;
  top:15px;
  left:28%;
}
.loginbtn{
  width:35%;
  position: relative;
  top:15px;
  left:-5%; 
}
.back{
  position: relative;
  top:50px;
  left:30%;
  font-size: 40px;
}
}
/* 600px〜959px：タブレット
------------------------------ */
@media screen and (min-width:600px) and (max-width:959px) {
.all{
  position: relative;
}
.logo{
  position: relative;
  top:20%;
  left:30%;
  height: 250px; 
  max-height: 60%; 
}
.rightside{
  position: relative;
  top:10%;
  left:10%;
}
.LoginFont{
  position: relative;
  font-size: 35px;
  left:30%;
}
.errbar{
  position: relative;
  left:8%;
}
.mailConform{
  position: relative;
  top:25px;
  left:15px;
}
.mailConformFont{
  font-size:25px;
}
.passwordConformFont{
  font-size:25px;
}
.mailform{
  max-width: 100%;
  font-size:18px;
}
.passwordform{
  max-width: 100%;
  font-size:18px;
}
.forgetpassword{
  position: relative;
  top:0%;
  left:50%;
  font-size:40px;
}
.forgetpasswordtext{
  font-size:13px;
}
.checkbox{
  position: relative;
  top:15px;
  left:28%;
}
.loginbtn{
  width:45%;
  position: relative;
  top:15px;
  left:-5%; 
}
.back{
  position: relative;
  top:50px;
  left:50%;
  font-size: 40px;
}
}

/* 480px〜599px：スマートフォン横
------------------------------ */
@media screen and (min-width:480px) and (max-width:599px) {
.all{
  position: relative;
  left:1%;
  top:15%;
}
.logo{
  position: relative;
  top:10%;
  left:10%;
  height:200px;
  max-height: 40%;
}
.LoginFont{
  position: relative;
  font-size: 35px;
  left:30%;
}
.mailConform{
  position: relative;
  top:25px;
  left:15px;
}
.mailform{
  position: relative;
  width: calc(80% + 80px);
  max-width: none;
  margin: 0 0px;
}
.passwordform{
  position: relative;
  width: calc(80% + 80px);
  max-width: none;
  margin: 0 0px;
}
.forgetpassword{
  position: relative;
  top:0%;
  left:50%;
  font-size:40px;
}
.forgetpasswordtext{
  font-size:15px;
}
.checkbox{
  position: relative;
  top:15px;
  left:28%;
}
.loginbtn{
  width:65%;
  position: relative;
  top:15px;
  left:-5%; 
}
.back{
  position: relative;
  top:50px;
  left:50%;
  font-size: 25px;
}
.errbar{
  position: relative;
  top:20px;
  left:20%;
  font-size: 27px;
}
}

/* 〜479px：スマートフォン縦
------------------------------ */
@media screen and (max-width:479px) {
.all{
  position: relative;
  left:1%;
  top:5%;
}
.logo{
  position: relative;
  top:0%;
  left:100%;
  height:200px;
  max-height: 40%;
}
.rightside{
  position: relative;
  top:10%;
  left:0%;
}
.LoginFont{
  position: relative;
  font-size: 35px;
  top:250px;
  left:0%;
}
.mailConform{
  position: relative;
  top:280px;
  left:-100px;
}
.mailform{
  position: relative;
  top:-15px;
  width: calc(120% + 120px);
  max-width: none;
  margin: 0 0px;
}
.passwordform{
  position: relative;
  top:-15px;
  width: calc(120% + 120px);
  max-width: none;
  margin: 0 0px;
}
.forgetpassword{
  position: relative;
  top:270px;
  left:60%;
}
.forgetpasswordtext{
  font-size:15px;
}
.checkbox{
  position: relative;
  top:300px;
  left:-20%;
}
.linebtn{
  margin-top: 200%;
  width: 160%;
}
.loginbtn{
  width:100%;
  position: relative;
  top:300px;
  left:-5%; 
}
.back{
  position: relative;
  top:320px;
  left:30%;
  font-size: 27px;
}
.errbar{
  position: relative;
  top:250px;
  left:0%;
  font-size: 27px;
}
}
</style>
